/* FashionOwn homepage behaviour: hero slider, product tabs, personalisation
   preview. Each block initialises from its own markup, so sections can be
   reordered or removed in the theme editor without breaking the others. */
(function () {
  function initSlider(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-fo-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-fo-dot]'));
    var count = root.querySelector('[data-fo-count]');
    if (slides.length < 2) return;
    var cur = 0;
    function go(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== cur; });
      dots.forEach(function (d, k) {
        d.setAttribute('aria-selected', k === cur ? 'true' : 'false');
        d.tabIndex = k === cur ? 0 : -1;
      });
      if (count) count.textContent = (cur + 1) + ' / ' + slides.length;
    }
    var prev = root.querySelector('[data-fo-prev]');
    var next = root.querySelector('[data-fo-next]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) go(cur + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    root.addEventListener('keydown', function (e) {
      if (e.target.closest('input, textarea')) return;
      if (e.key === 'ArrowRight') go(cur + 1);
      if (e.key === 'ArrowLeft') go(cur - 1);
    });
  }

  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-fo-tab]'));
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        select(n);
        n.focus();
      });
    });
  }

  function initPersonaliser(root) {
    var inName = root.querySelector('[data-fo-in-name]');
    var inNum = root.querySelector('[data-fo-in-num]');
    var outName = root.querySelector('[data-fo-out-name]');
    var outNum = root.querySelector('[data-fo-out-num]');
    if (!inName || !inNum) return;
    function sync() {
      var n = inName.value.trim().toUpperCase();
      outName.textContent = n || outName.getAttribute('data-default');
      var d = inNum.value.replace(/[^0-9]/g, '');
      if (inNum.value !== d) inNum.value = d;
      outNum.textContent = d || outNum.getAttribute('data-default');
    }
    inName.addEventListener('input', sync);
    inNum.addEventListener('input', sync);
  }

  // Hero slider (sections/fo-slider.liquid): one horizontal track that moves
  // by 100% per slide. Plays automatically unless the visitor prefers reduced
  // motion; pauses on hover, keyboard focus, a hidden tab or the pause button.
  function initCarousel(root) {
    if (root.__foInit) return;
    root.__foInit = true;
    var track = root.querySelector('[data-fo-track]');
    var viewport = root.querySelector('[data-fo-viewport]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-fo-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-fo-dot]'));
    var count = root.querySelector('[data-fo-count]');
    var pauseBtn = root.querySelector('[data-fo-pause]');
    var n = slides.length;
    if (!track || !viewport || n === 0) return;

    var cur = 0;
    var timer = null;
    var hover = false;
    var focused = false;
    var userPaused = false;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto = root.getAttribute('data-autoplay') === 'true' && n > 1 && !reduce;
    var delay = Math.max(3, parseFloat(root.getAttribute('data-speed')) || 6) * 1000;

    function render() {
      track.style.transform = 'translateX(' + (-cur * 100) + '%)';
      slides.forEach(function (s, k) {
        var on = k === cur;
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if ('inert' in s) s.inert = !on;
      });
      dots.forEach(function (d, k) {
        d.setAttribute('aria-selected', k === cur ? 'true' : 'false');
        d.tabIndex = k === cur ? 0 : -1;
      });
      if (count) count.textContent = (cur + 1) + ' / ' + n;
    }
    function go(i) { cur = (i + n) % n; render(); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (auto && !userPaused && !hover && !focused && !document.hidden) {
        timer = setInterval(function () { go(cur + 1); }, delay);
      }
    }
    function userGo(i) { go(i); start(); }

    var prev = root.querySelector('[data-fo-prev]');
    var next = root.querySelector('[data-fo-next]');
    if (prev) prev.addEventListener('click', function () { userGo(cur - 1); });
    if (next) next.addEventListener('click', function () { userGo(cur + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { userGo(k); }); });

    if (pauseBtn) {
      if (!auto) pauseBtn.hidden = true;
      pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
        if (userPaused) stop(); else start();
      });
    }

    root.addEventListener('mouseenter', function () { hover = true; stop(); });
    root.addEventListener('mouseleave', function () { hover = false; start(); });
    root.addEventListener('focusin', function () { focused = true; stop(); });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) { focused = false; start(); }
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });

    // Drag / swipe: the track follows the finger, then settles on a slide.
    var x0 = 0;
    var dx = 0;
    var dragging = false;
    var moved = false;
    viewport.addEventListener('pointerdown', function (e) {
      if (n < 2 || (e.pointerType === 'mouse' && e.button !== 0)) return;
      x0 = e.clientX; dx = 0; dragging = true; moved = false;
      track.classList.add('is-dragging');
      stop();
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dx = e.clientX - x0;
      if (Math.abs(dx) > 6) moved = true;
      track.style.transform = 'translateX(calc(' + (-cur * 100) + '% + ' + dx + 'px))';
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      var threshold = Math.min(80, (viewport.clientWidth || 400) * 0.15);
      if (Math.abs(dx) > threshold) go(cur + (dx < 0 ? 1 : -1)); else render();
      start();
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    // A drag must not also count as a click on a slide's button.
    viewport.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

    root.addEventListener('keydown', function (e) {
      if (e.target.closest('input, textarea')) return;
      if (e.key === 'ArrowRight') userGo(cur + 1);
      if (e.key === 'ArrowLeft') userGo(cur - 1);
    });

    // Theme editor: selecting a slide block shows it and holds it still.
    document.addEventListener('shopify:block:select', function (e) {
      var i = slides.indexOf(e.target);
      if (i >= 0) { go(i); userPaused = true; stop(); }
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      if (slides.indexOf(e.target) >= 0) { userPaused = false; start(); }
    });

    render();
    start();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-fo-carousel]').forEach(initCarousel);
    (scope || document).querySelectorAll('[data-fo-slider]').forEach(initSlider);
    (scope || document).querySelectorAll('[data-fo-tabs]').forEach(initTabs);
    (scope || document).querySelectorAll('[data-fo-personaliser]').forEach(initPersonaliser);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Re-initialise a section after it's edited in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
